import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, HostBinding, ViewChild, NgModule } from '@angular/core';
import * as i1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3 from '@storeblocks/surface-ng';
import { SurfaceModule } from '@storeblocks/surface-ng';
const _c0 = ["cardNavigation"];
const _c1 = ["cardNgContent"];
const _c2 = ["*"];
function CardNavigationComponent_div_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CardNavigationComponent_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6, 2);
    i0.ɵɵlistener("click", function CardNavigationComponent_div_1_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCardClick($event));
    })("keydown.enter", function CardNavigationComponent_div_1_Template_div_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCardClick($event));
    });
    i0.ɵɵtemplate(2, CardNavigationComponent_div_1_ng_container_2_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const cardContent_r3 = i0.ɵɵreference(4);
    i0.ɵɵclassMapInterpolate1("card-nav-base ", ctx_r1.colorVariant, "");
    i0.ɵɵclassProp("fluid", ctx_r1.fluid);
    i0.ɵɵattribute("data-size", ctx_r1.size)("data-trackid", ctx_r1.trackId)("data-stb-navigation-card", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", cardContent_r3);
  }
}
function CardNavigationComponent_div_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CardNavigationComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6, 2);
    i0.ɵɵlistener("click", function CardNavigationComponent_div_2_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCardClick($event));
    })("keydown.enter", function CardNavigationComponent_div_2_Template_div_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onCardClick($event));
    });
    i0.ɵɵtemplate(2, CardNavigationComponent_div_2_ng_container_2_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const cardContent_r3 = i0.ɵɵreference(4);
    i0.ɵɵclassMapInterpolate1("card-nav-base ", ctx_r1.colorVariant, "");
    i0.ɵɵclassProp("fluid", ctx_r1.fluid);
    i0.ɵɵattribute("data-size", ctx_r1.size)("data-trackid", ctx_r1.trackId)("data-stb-navigation-card", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", cardContent_r3);
  }
}
function CardNavigationComponent_ng_template_3_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16);
    i0.ɵɵelement(2, "img");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-hidden", ctx_r1.alt ? null : "true");
    i0.ɵɵadvance();
    i0.ɵɵattribute("alt", ctx_r1.alt)("src", ctx_r1.iconPath, i0.ɵɵsanitizeUrl);
  }
}
function CardNavigationComponent_ng_template_3_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16);
    i0.ɵɵelement(2, "img", 17);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-hidden", ctx_r1.alt ? null : "true");
    i0.ɵɵadvance();
    i0.ɵɵattribute("alt", ctx_r1.alt)("src", ctx_r1.iconPath, i0.ɵɵsanitizeUrl);
  }
}
function CardNavigationComponent_ng_template_3_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CardNavigationComponent_ng_template_3_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CardNavigationComponent_ng_template_3_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const cardLinks_r5 = i0.ɵɵreference(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", cardLinks_r5);
  }
}
function CardNavigationComponent_ng_template_3_i_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 18);
    i0.ɵɵtext(1, " arrow-right ");
    i0.ɵɵelementEnd();
  }
}
function CardNavigationComponent_ng_template_3_ng_container_7_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CardNavigationComponent_ng_template_3_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CardNavigationComponent_ng_template_3_ng_container_7_ng_container_1_Template, 1, 0, "ng-container", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const cardLinks_r5 = i0.ɵɵreference(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", cardLinks_r5);
  }
}
function CardNavigationComponent_ng_template_3_p_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 19);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.caption, " ");
  }
}
function CardNavigationComponent_ng_template_3_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 20, 3);
    i0.ɵɵprojection(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
}
function CardNavigationComponent_ng_template_3_i_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "i", 21);
    i0.ɵɵtext(1, " arrow-right ");
    i0.ɵɵelementEnd();
  }
}
function CardNavigationComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "div", 9);
    i0.ɵɵtemplate(2, CardNavigationComponent_ng_template_3_div_2_Template, 3, 3, "div", 10)(3, CardNavigationComponent_ng_template_3_div_3_Template, 3, 3, "div", 10)(4, CardNavigationComponent_ng_template_3_ng_container_4_Template, 2, 1, "ng-container", 11)(5, CardNavigationComponent_ng_template_3_i_5_Template, 2, 0, "i", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵtemplate(7, CardNavigationComponent_ng_template_3_ng_container_7_Template, 2, 1, "ng-container", 11)(8, CardNavigationComponent_ng_template_3_p_8_Template, 2, 1, "p", 13);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(9, CardNavigationComponent_ng_template_3_ng_container_9_Template, 4, 0, "ng-container", 11)(10, CardNavigationComponent_ng_template_3_i_10_Template, 2, 0, "i", 14);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.size === "large" && ctx_r1.iconPath);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.size !== "large" && ctx_r1.iconPath);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.iconPath && ctx_r1.text);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.size === "large");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.iconPath && ctx_r1.text);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.size === "large" || ctx_r1.size === "medium" || ctx_r1.size === "small") && ctx_r1.caption);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.size === "large");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.size !== "large");
  }
}
function CardNavigationComponent_ng_template_5_a_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 24);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("href", ctx_r1.link ? ctx_r1.link : null, i0.ɵɵsanitizeUrl)("target", ctx_r1.openInNewWindow ? "_blank" : null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.text, " ");
  }
}
function CardNavigationComponent_ng_template_5_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 25);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("routerLink", ctx_r1.route ? ctx_r1.route : null);
    i0.ɵɵattribute("target", ctx_r1.openInNewWindow ? "_blank" : null);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.text, " ");
  }
}
function CardNavigationComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CardNavigationComponent_ng_template_5_a_0_Template, 2, 3, "a", 22)(1, CardNavigationComponent_ng_template_5_a_1_Template, 2, 3, "a", 23);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r1.route);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.route);
  }
}
let CardNavigationComponent = /*#__PURE__*/(() => {
  class CardNavigationComponent {
    constructor(router) {
      this.router = router;
      this.alt = '';
      this.caption = '';
      this.colorVariant = 'onBackground';
      this.iconPath = '';
      this.id = '';
      this.role = '';
      /**
       * The link to navigate to.
       * If empty, useEvents will be set to true and cardClick-event will be emitted.
       */
      this.link = '';
      /**
       * Angular router link, use this OR `link` (not both)
       */
      this.route = '';
      this.openInNewWindow = false;
      this.size = 'large';
      this.fluid = false;
      this.text = '';
      this.trackId = '';
      /**
       * Add class `font-paragraph` if we find a <p> tag in ng-content
       * @type {boolean}
       * @default false
      */
      this.addParagraphClasses = false;
      /**
      * Use your own event-handler instead of acting as a regular link.
      * Link will be "defanged" using preventDefault().
      * Listen for the (cardClick) or (cardRoute) event to handle the click/route event.
      * @type {boolean}
      * @default false
      */
      this.useEvents = false;
      this.cardClick = new EventEmitter();
      this.cardRoute = new EventEmitter();
      this.surfaceVariant = 'background';
    }
    get roleAttr() {
      return this.role ? this.role : null;
    }
    ngOnInit() {
      switch (this.colorVariant) {
        case 'onBackground':
          this.surfaceVariant = 'background';
          break;
        case 'onSurface1':
          this.surfaceVariant = 'surface-1';
          break;
        default:
          this.surfaceVariant = 'background';
      }
    }
    ngAfterViewInit() {
      // Add "font-paragraph" class to <p> tags in ng-content
      if (this.addParagraphClasses) {
        const pElems = this.cardNgContent?.nativeElement?.querySelectorAll('p');
        if (pElems) {
          pElems.forEach(pTag => {
            if (!pTag.classList.contains('font-paragraph')) {
              pTag.classList.add('font-paragraph');
            }
          });
        }
      }
    }
    onCardClick($event) {
      // Only send event
      if (this.useEvents) {
        $event.preventDefault();
        $event.stopPropagation();
        this.cardClick.emit(this.id);
      }
      // Angular route
      if (this.route.length > 0) {
        if (typeof this.route === 'string') {
          this.router.navigate([this.route]);
        } else {
          this.router.navigate(this.route);
        }
      }
      // Plain link
      if (!this.useEvents && !this.route) {
        // KISS: just find the link and click it
        this.cardNavigation.nativeElement.querySelectorAll('a')[0].click();
      }
    }
  }
  CardNavigationComponent.ɵfac = function CardNavigationComponent_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CardNavigationComponent)(i0.ɵɵdirectiveInject(i1.Router));
  };
  CardNavigationComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: CardNavigationComponent,
    selectors: [["stb-card-navigation"]],
    viewQuery: function CardNavigationComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cardNavigation = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.cardNgContent = _t.first);
      }
    },
    hostVars: 1,
    hostBindings: function CardNavigationComponent_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("role", ctx.roleAttr);
      }
    },
    inputs: {
      alt: "alt",
      caption: "caption",
      colorVariant: "colorVariant",
      iconPath: "iconPath",
      id: "id",
      role: "role",
      link: "link",
      route: "route",
      openInNewWindow: "openInNewWindow",
      size: "size",
      fluid: "fluid",
      text: "text",
      trackId: "trackId",
      addParagraphClasses: "addParagraphClasses",
      useEvents: "useEvents"
    },
    outputs: {
      cardClick: "cardClick",
      cardRoute: "cardRoute"
    },
    ngContentSelectors: _c2,
    decls: 7,
    vars: 3,
    consts: [["cardContent", ""], ["cardLinks", ""], ["cardNavigation", ""], ["cardNgContent", ""], ["data-stb-surface", "true", 1, "surfaceBase", 2, "background-color", "transparent", 3, "variant"], ["tabindex", "0", 3, "class", "fluid", "click", "keydown.enter", 4, "ngIf"], ["tabindex", "0", 3, "click", "keydown.enter"], [4, "ngTemplateOutlet"], [1, "nav-card-header"], [1, "nav-card-wrapper"], ["class", "card-nav-graphic", 4, "ngIf"], [4, "ngIf"], ["class", "symbolBase card-nav-arrow-icon-lg", "aria-hidden", "true", "translate", "no", 4, "ngIf"], ["class", "font-caption card-nav-caption", 4, "ngIf"], ["class", "symbolBase card-nav-arrow-icon", "aria-hidden", "true", "translate", "no", 4, "ngIf"], [1, "card-nav-graphic"], ["data-stb-icon", "true", 1, "icon", "iconBase"], [2, "width", "100%", "height", "100%"], ["aria-hidden", "true", "translate", "no", 1, "symbolBase", "card-nav-arrow-icon-lg"], [1, "font-caption", "card-nav-caption"], [1, "nav-card-ng-content"], ["aria-hidden", "true", "translate", "no", 1, "symbolBase", "card-nav-arrow-icon"], ["class", "font-large card-nav-title", 4, "ngIf"], ["class", "font-large card-nav-title", 3, "routerLink", 4, "ngIf"], [1, "font-large", "card-nav-title"], [1, "font-large", "card-nav-title", 3, "routerLink"]],
    template: function CardNavigationComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵprojectionDef();
        i0.ɵɵelementStart(0, "stb-surface", 4);
        i0.ɵɵtemplate(1, CardNavigationComponent_div_1_Template, 3, 9, "div", 5)(2, CardNavigationComponent_div_2_Template, 3, 9, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(3, CardNavigationComponent_ng_template_3_Template, 11, 8, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(5, CardNavigationComponent_ng_template_5_Template, 2, 2, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        i0.ɵɵproperty("variant", ctx.surfaceVariant === "background" ? "background" : "surface-1");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.route);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.route);
      }
    },
    dependencies: [i2.NgIf, i2.NgTemplateOutlet, i3.SurfaceComponent, i1.RouterLinkWithHref],
    styles: ["@font-face{font-family:SignaWeb-Book;src:url(https://assets.storebrand.no/fonts/Signa/SignaWeb-Book.woff) format(\"woff\");font-display:swap}@font-face{font-family:SignaWeb-Light;src:url(https://assets.storebrand.no/fonts/Signa/SignaWeb-Light.woff) format(\"woff\");font-display:swap}@font-face{font-family:Open Sans;font-style:normal;font-weight:400 700;font-variation-settings:\"wght\" 400 700;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Open Sans Semibold;font-style:normal;font-weight:600;font-variation-settings:\"wght\" 600;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Open Sans Bold;font-style:normal;font-weight:700;font-variation-settings:\"wght\" 700;src:url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2 supports variations\"),url(https://assets.storebrand.no/fonts/OpenSans/OpenSans.woff2) format(\"woff2-variations\");font-display:swap}@font-face{font-family:Storebrand Display;font-stretch:100%;font-style:normal;font-weight:400 700;font-display:swap;src:url(https://assets-t.storebrand.no/fonts/Storebrand/StorebrandDisplay.woff2) format(\"woff2\")}@font-face{font-family:Storebrand Text;font-style:normal;font-weight:400 700;font-stretch:100%;font-display:swap;src:url(https://assets-t.storebrand.no/fonts/Storebrand/StorebrandText.woff2) format(\"woff2\")}@font-face{font-family:System-Icons;src:url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.eot) format(\"eot\"),url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.woff) format(\"woff\"),url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.woff2) format(\"wolf2\"),url(https://assets.storebrand.no/fonts/System-Icons/System-Icons.ttf) format(\"truetype\");text-rendering:optimizeLegibility}@font-face{font-family:Storebrand Symbols;src:url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.eot) format(\"eot\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.woff) format(\"woff\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.woff2) format(\"wolf2\"),url(https://assets.storebrand.no/fonts/Symbols/StorebrandSymbols.ttf) format(\"truetype\");text-rendering:optimizeLegibility}i.symbol{font-family:Storebrand Symbols!important}i{font-family:System-Icons!important;font-style:normal;font-weight:400!important;font-size:16px;line-height:16px;white-space:nowrap;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}i:empty:not([class*=system-icon]){display:inline-flex;width:24px;height:24px;background:var(--color-primary)}.icon-xsmall{font-size:16px!important;line-height:16px!important}.icon-small{font-size:20px!important;line-height:20px!important}.icon-medium{font-size:24px!important;line-height:24px!important}.icon-large{font-size:32px!important;line-height:32px!important}.card-nav-base[data-stb-navigation-card=true]{--foreground-color: var(--p-color-red-800);--background-color: var(--p-color-red-200);--card-padding-size: var(--p-spacing-24, 24px);background:var(--card-background, var(--p-color-background));border:1px solid transparent;border-radius:var(--p-corner-radius-medium);box-sizing:border-box;color:var(--foreground-color);cursor:pointer;display:flex;gap:var(--p-spacing-rem-16);padding:var(--card-padding-size);text-decoration:none;transition-duration:var(--p-transition-duration);transition-property:background-color}.card-nav-base[data-stb-navigation-card=true]:hover{background:var(--card-hover-background)}.card-nav-base[data-stb-navigation-card=true]:active{background:var(--p-color-grey-300)}.card-nav-base[data-stb-navigation-card=true]:focus-visible{outline:2px solid var(--p-color-states-focus, #00f);outline-offset:var(--p-outline-offset, 2px)}.card-nav-base[data-stb-navigation-card=true] .card-nav-arrow-icon{font-size:20px;height:20px;line-height:20px;width:20px}.card-nav-base[data-stb-navigation-card=true] .card-nav-arrow-icon-lg{margin-left:auto;font-size:24px;line-height:24px;width:24px;height:24px}.card-nav-base[data-stb-navigation-card=true] .nav-card-wrapper{display:flex;justify-content:space-between}.card-nav-base[data-stb-navigation-card=true] .card-nav-title{font-weight:600;text-decoration:none;display:inline-block}.card-nav-base[data-stb-navigation-card=true] .card-nav-title.title-no-icon{margin-top:0;margin-bottom:0}.card-nav-base[data-stb-navigation-card=true] .nav-card-header:has(.card-nav-title) .card-nav-caption{margin-top:4px}.card-nav-base[data-stb-navigation-card=true][data-size=large]{flex-direction:column}.card-nav-base[data-stb-navigation-card=true][data-size=large] .nav-card-header:has(img) .card-nav-caption,.card-nav-base[data-stb-navigation-card=true][data-size=large] .nav-card-header:has(.card-nav-title) .card-nav-caption{margin-top:4px}.card-nav-base[data-stb-navigation-card=true][data-size=large] .nav-card-ng-content{margin-top:0}.card-nav-base[data-stb-navigation-card=true][data-size=large] .card-nav-graphic{height:96px;width:96px}.card-nav-base[data-stb-navigation-card=true][data-size=large] .card-nav-title{font-weight:600;margin-top:var(--p-spacing-rem-16)}.card-nav-base[data-stb-navigation-card=true][data-size=large] .nav-card-wrapper{align-items:flex-start}.card-nav-base[data-stb-navigation-card=true][data-size=large] .nav-card-header:not(:has(.card-nav-graphic)) .card-nav-title{margin-top:0;margin-bottom:0}.card-nav-base[data-stb-navigation-card=true][data-size=medium],.card-nav-base[data-stb-navigation-card=true][data-size=small],.card-nav-base[data-stb-navigation-card=true][data-size=compact]{align-items:center}.card-nav-base[data-stb-navigation-card=true][data-size=medium] .nav-card-header:has(img),.card-nav-base[data-stb-navigation-card=true][data-size=small] .nav-card-header:has(img),.card-nav-base[data-stb-navigation-card=true][data-size=compact] .nav-card-header:has(img){align-items:center;display:flex}.card-nav-base[data-stb-navigation-card=true][data-size=medium] .card-nav-graphic,.card-nav-base[data-stb-navigation-card=true][data-size=small] .card-nav-graphic,.card-nav-base[data-stb-navigation-card=true][data-size=compact] .card-nav-graphic{height:64px;width:64px}.card-nav-base[data-stb-navigation-card=true][data-size=medium] .card-nav-graphic:not(:has(img)),.card-nav-base[data-stb-navigation-card=true][data-size=small] .card-nav-graphic:not(:has(img)),.card-nav-base[data-stb-navigation-card=true][data-size=compact] .card-nav-graphic:not(:has(img)){margin-right:0}.card-nav-base[data-stb-navigation-card=true][data-size=medium] .card-nav-graphic:has(img),.card-nav-base[data-stb-navigation-card=true][data-size=small] .card-nav-graphic:has(img),.card-nav-base[data-stb-navigation-card=true][data-size=compact] .card-nav-graphic:has(img){margin-right:var(--p-spacing-rem-16)}.card-nav-base[data-stb-navigation-card=true][data-size=medium] .card-nav-title,.card-nav-base[data-stb-navigation-card=true][data-size=small] .card-nav-title,.card-nav-base[data-stb-navigation-card=true][data-size=compact] .card-nav-title{font-size:var(--p-font-styles-size-18, 18px);line-height:var(--p-font-styles-line-height-desktop-18, 26px)}.card-nav-base[data-stb-navigation-card=true][data-size=large]{width:344px}.card-nav-base[data-stb-navigation-card=true][data-size=large].fluid{width:clamp(252px,100%,528px)}.card-nav-base[data-stb-navigation-card=true][data-size=medium]{width:434px}.card-nav-base[data-stb-navigation-card=true][data-size=medium].fluid{width:clamp(252px,100%,528px)}.card-nav-base[data-stb-navigation-card=true][data-size=small]{width:344px;--card-padding-size: var(--p-spacing-rem-16)}.card-nav-base[data-stb-navigation-card=true][data-size=small] .card-nav-arrow-icon{margin-left:auto}.card-nav-base[data-stb-navigation-card=true][data-size=small] .card-nav-graphic{height:64px;width:64px}.card-nav-base[data-stb-navigation-card=true][data-size=small].fluid{width:clamp(252px,100%,434px)}.card-nav-base[data-stb-navigation-card=true][data-size=compact]{--card-padding-size: 16px;min-width:252px;max-width:528px;width:-moz-fit-content;width:fit-content}.card-nav-base[data-stb-navigation-card=true][data-size=compact] .card-nav-title{font-weight:400;margin-bottom:0}.card-nav-base[data-stb-navigation-card=true][data-size=compact] .card-nav-arrow-icon{margin-left:auto}.card-nav-base[data-stb-navigation-card=true][data-size=compact] .card-nav-graphic{height:48px;width:48px}.card-nav-base[data-stb-navigation-card=true][data-size=compact].fluid{width:clamp(252px,100%,528px)}\n"],
    encapsulation: 2,
    changeDetection: 0
  });
  return CardNavigationComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CardNavigationModule = /*#__PURE__*/(() => {
  class CardNavigationModule {}
  CardNavigationModule.ɵfac = function CardNavigationModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CardNavigationModule)();
  };
  CardNavigationModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: CardNavigationModule
  });
  CardNavigationModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, SurfaceModule, RouterModule]
  });
  return CardNavigationModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of card-navigation
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CardNavigationComponent, CardNavigationModule };
